import { useEffect, useState } from "react";
import { TableComponent } from "..";
import { useModalControl } from "../../../customeHooks/useModalControl";
import { EventGuest } from "../../../redux/features/event/event.types";
import { PayoutCurrency } from "../../../redux/features/payment/payment.types";
import { getTimeAgo } from "../../../utils/helpers";
import { EventPermissions, TicketColor } from "../../../utils/types";
import { GuestCard } from "../../cards/guestCard";
import { ViewGuestModal } from "../../modal/app_modals/viewGuestModal";

export const GuestsTable = ({
  loading,
  guests,
  showTimeAgo,
  isPaginated,
  currentPage,
  totalCount,
  itemsPerPage,
  pageRangeDisplayed,
  onPageChange,
  ticketColor,
  qrScanId,
  setQrScanId = () => {},
  adminView = false,
  eventCurrency,
  userEventPermissions,
}: {
  loading: boolean;
  guests: EventGuest[];
  showTimeAgo: boolean;
  isPaginated?: boolean;
  currentPage?: number;
  totalCount?: number;
  itemsPerPage?: number;
  pageRangeDisplayed?: number;
  onPageChange?: (page: number) => void;
  ticketColor?: TicketColor;
  qrScanId?: string;
  setQrScanId?: (val: string | undefined) => void;
  adminView?: boolean;
  eventCurrency: PayoutCurrency;
  userEventPermissions: EventPermissions[];
}) => {
  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl();
  const [selectedGuest, setSelectedGuest] = useState<string>();

  useEffect(() => {
    if (qrScanId !== undefined) {
      handleModalOpen("viewGuestModal");
      setSelectedGuest(qrScanId);
    }
    // eslint-disable-next-line
  }, [qrScanId]);

  return (
    <>
      <TableComponent
        headers={[]}
        rows={guests.map((guest, idx) => {
          return {
            id: idx,
            items: [
              <GuestCard
                className=""
                name={`${guest.firstName} ${guest.lastName}`}
                email={`${guest.email}`}
                timeAgo={showTimeAgo ? getTimeAgo(guest.createdAt) : undefined}
                key={`guests-row-${idx}`}
                hideEmailOnMobile
                guest={guest}
                ticketColor={ticketColor}
              />,
            ],
          };
        })}
        onRowClick={(idx) => {
          setSelectedGuest(guests[idx]._id);
          handleModalOpen("viewGuestModal");
        }}
        isLoading={loading}
        isRowClickable
        isTableEmpty={[0, undefined].includes(guests.length)}
        emptyTitle="No Registered Guest Yet"
        emptySubTitle="Share the event or invite people to get started!"
        emptyImage="/assets/images/guest-glass.png"
        isPaginated={isPaginated}
        currentPage={currentPage}
        totalCount={totalCount}
        itemsPerPage={itemsPerPage}
        pageRangeDisplayed={pageRangeDisplayed}
        onPageChange={onPageChange}
      />

      <ViewGuestModal
        open={
          modal === "viewGuestModal" && modalOpen && selectedGuest !== undefined
        }
        handleClose={() => {
          handleModalClose();
          setSelectedGuest(undefined);
          setQrScanId(undefined);
        }}
        guestId={selectedGuest ?? ""}
        adminView={adminView}
        eventCurrency={eventCurrency}
        userEventPermissions={userEventPermissions}
      />
    </>
  );
};
